import { FC, useEffect, useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useNavigate } from 'react-router'
import errorAlert from '../../assets/images/error-alert.svg'
import success from '../../assets/images/success.svg'
import { ETR_STATUS } from '../../constants'
import { DisplayStatusName } from '../../helpers/texthelper'
import { ConfirmModalProps } from '../../models/component'
import { DocumentModel } from '../../models/document'
import { handleGetDocumentById } from '../../redux/actions/document.detail.action'
import { completeTransction } from '../../redux/actions/transaction.edit.action'
import { RootReducers } from '../../redux/reducers'
import { LoadingOverlay } from '../loadingOverlay'
import { ERROR_MESSAGE } from '../../constants/errorMessage'

const ModalTransferComplete: FC<ConfirmModalProps> = ({
  data,
  isOpenModal,
  handleCancelbutton
}) => {
  const navigate = useNavigate()
  const store = useStore<RootReducers>()
  const dispatch = useDispatch()
  const documentData = useSelector((state: RootReducers) => state.documentDetailReducer)
  const [reasonText, setReasonText] = useState('')
  const [processing, setProcessing] = useState(false)
  const shouldUploadChangeMobileOrEmail =
    documentData.documentModel?.hasChangeEmailOrMobile === true &&
    !documentData.documentModel.changeEmailOrMobileFile

  const getData = async () => {
    try {
      if (data.id) {
        setProcessing(true)
        await dispatch(handleGetDocumentById(String(data.id)))
      }
    } catch (error) {
      handleCancelbutton()
      console.error(error)
    } finally {
      setProcessing(false)
    }
  }

  useEffect(() => {
    if (data && isOpenModal) {
      getData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isOpenModal])

  const handleTextConfirm = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value: text } = event.target
    setReasonText(text)
    data.reasonText = text
  }

  const handleComfirm = () => {
    const date = new Date()

    if (data.eTRNo.length > 0) {
      const statusDate = new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes()
        )
      )
      const docData: DocumentModel = {
        updateBy: store.getState().loginReducer.account?.agentInfo.userName,
        id: data.id,
        status: ETR_STATUS.SUCCESS_ETR,
        statusReason: data.reasonText,
        statusDate: statusDate,
        etrStatusDate: statusDate
      }
      dispatch(completeTransction(data.id, docData))
      handleCancelbutton()
      navigate('/summary', {
        state: {
          message: `ยืนยันการรับเงิน ใบรับเงินชั่วคราว<br/>
        <b>หมายเลข ${data.eTRNo}</b><br/>
        เรียบร้อยแล้ว`,
          icon: success
        }
      })
    }
  }

  const disableStatus = [ETR_STATUS.CANCEL_ETR, ETR_STATUS.SUCCESS_ETR].includes(
    documentData.documentModel?.status as string
  )
  const isDisableBtnSubmit = disableStatus || shouldUploadChangeMobileOrEmail

  return (
    <Modal
      isOpen={isOpenModal}
      onAfterClose={() => {
        data.reasonText = ''
      }}
      className="modal-cancel"
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(24, 48, 40, 0.9)'
        }
      }}
      ariaHideApp={false}
    >
      {processing && <LoadingOverlay />}
      <div className="modal-cancel-content">
        <div>
          <div className="modal-cancel-header-text">ปรับสถานะ e-TR Billpay/กธ.IL {data.eTRNo} </div>
          <div style={{ marginBottom: 85, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <textarea
              placeholder="กรุณาระบุเหตผลในการรับเงิน"
              value={reasonText}
              onChange={e => handleTextConfirm(e)}
            />
            {disableStatus && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                {`ไม่สามารถทำรายการได้เนื่องจากรายการนี้ได้ถูกดำเนินการปรับสถานะเป็น "${DisplayStatusName(
                  documentData.documentModel?.status
                )}" แล้ว`}
              </div>
            )}
            {shouldUploadChangeMobileOrEmail && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                {ERROR_MESSAGE.REQUIRED_HAS_CHANGE_EMAIL_OR_MOBILE}
              </div>
            )}
          </div>
        </div>
        <div className="modal-cancel-group-button">
          <button className="cancel-transaction-button" onClick={() => handleCancelbutton()}>
            ยกเลิก
          </button>
          <button
            className="confirm-transaction-button"
            onClick={handleComfirm}
            disabled={isDisableBtnSubmit}
          >
            ยืนยัน
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalTransferComplete
